import { WebTimeRecordType } from './webtimerecordtype';

export class WebTimeRecord {
    constructor(
        readonly recordType: WebTimeRecordType,
        readonly timestamp: Date ) { }
}
